"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bandSetPreviewInputSchema = exports.blastRadiusShownSchema = exports.blastRadiusSchema = exports.blastRadiusFacilitySchema = void 0;
/**
 * `RPM-060` — the blast radius of a change that alters clinical behaviour, shown before the commit
 * (`J-294`).
 *
 * TWO SHAPES, AND THE DIFFERENCE IS THE POINT. The preview (`blastRadiusSchema`) is what is true
 * when it is asked: the buildings by name, and the residents and in-flight alerts as counts. The
 * commit carries back `blastRadiusShownSchema` — the counts as the administrator saw them and the
 * moment they were computed — "so the record shows what was seen, not what is true now".
 *
 * COUNTS ONLY. No resident is named, listed or identified in either shape; a building is
 * configuration, not patient data.
 */
const zod_1 = require("zod");
/** The mirror's identifier width. `carease.facilities.id` is varchar(20), and no FK reaches it. */
const MIRROR_ID = zod_1.z.string().min(1).max(20);
/** One building the change reaches: its mirror id and the mirror's name for it. */
exports.blastRadiusFacilitySchema = zod_1.z
    .object({
    facilityId: MIRROR_ID,
    name: zod_1.z.string(),
})
    .meta({ id: "BlastRadiusFacility", description: "A building a change reaches" });
/** The answer of `POST /api/rpm/v1/admin/**\/preview`: what the change touches, right now. */
exports.blastRadiusSchema = zod_1.z
    .object({
    /** Facilities affected — the count and the list (`RPM-060`'s operator surface). */
    facilities: zod_1.z.array(exports.blastRadiusFacilitySchema),
    /** Distinct residents with a reading at those buildings received in the last 30 days. */
    residents: zod_1.z.number().int().nonnegative(),
    /** Alerts at those buildings in `CLASSIFIED`, `BLOCKED` or `NOTIFY_OWED` (§10.5). */
    alertsInFlight: zod_1.z.number().int().nonnegative(),
    /** The database's instant of the count, ISO 8601. */
    computedAt: zod_1.z.iso.datetime({ offset: true }),
})
    .meta({
    id: "BlastRadius",
    description: "The facilities, residents and in-flight alerts a change touches",
});
/** What a commit carries back: the counts the administrator was shown, and when they were computed. */
exports.blastRadiusShownSchema = zod_1.z
    .strictObject({
    facilities: zod_1.z.number().int().nonnegative(),
    residents: zod_1.z.number().int().nonnegative(),
    alertsInFlight: zod_1.z.number().int().nonnegative(),
    computedAt: zod_1.z.iso.datetime({ offset: true }),
})
    .meta({
    id: "BlastRadiusShown",
    description: "The blast radius as it was shown before the commit",
});
/**
 * The body of `POST /api/rpm/v1/admin/band-sets/preview`: the set a publish would supersede.
 *
 * A band set is tenant-wide (`RPM-086`), so the set names the scope; naming it also lets the
 * preview refuse a stale screen whose set is no longer the tenant's current one.
 */
exports.bandSetPreviewInputSchema = zod_1.z
    .strictObject({
    classificationBandSetId: zod_1.z.uuid(),
})
    .meta({ description: "The current band set a publish would supersede" });
//# sourceMappingURL=rpm-blast-radius.js.map